var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('uml-class-model-canvas',{ref:"designer",attrs:{"elementListBeanPath":"classDefinitions","relationListBeanPath":"relations","relationVueComponentName":"uml-class-relation"}})}
var staticRenderFns = []

export { render, staticRenderFns }